<template>
  <div class="blue-wrap">
    <div class="blue-title">马上了解睿泽，让您的公司管理更便捷、更高效、更智能</div>
    <div class="blue-button">
      <div class="blue-btn row-center">
        <router-link to="/products" class="wk-blue-btn">立即了解睿泽</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'understand',
  data() {
    return {}
  }
}
</script>
<style scoped>
.blue-wrap {
  width: 100%;
  background-color: #172B4D;
  padding: 70px;
}
.blue-wrap .blue-title {
  color: #fff;
  font-size: 36px;
  text-align: center;
}
.blue-btn {
  margin-top: 30px;
}
.blue-btn .blue-free {
  background: #FFAB00;
  border-radius: 3px;
  color: #172B4D;
  padding: 5px 10px;
  border-radius: 4px;
  margin-right: 20px;
  border: 1px solid #FFAB00;
  cursor: pointer;
}
.blue-btn .blue-demo {
  color: #fff;
  border: 1px solid #fff;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}
.wk-blue-btn {
  line-height: normal;
  padding: 15px 30px;
  background-color: #FFAB00;
  border-radius: 3px;
  font-size: 16px;
  color: #172B4D;
  cursor: pointer;
}
.wk-blue-btn:hover {
  background-color: #FFC400;
}
.row-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/understand.vue